(function () {
  // Desktop: hover over en farve-swatch viser det produkts billede i kortet.
  function getCard(el) {
    return el.closest('.card-wrapper');
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('[data-color-url]');
    if (!swatch) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var card = getCard(swatch);
    if (!card) return;
    var preview = card.querySelector('.card__color-preview');
    if (!preview) return;

    preview.style.backgroundImage = "url('" + swatch.getAttribute('data-color-url') + "')";
    preview.classList.add('is-visible');
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('[data-color-url]');
    if (!swatch) return;

    // Bevæger man sig til en anden swatch i samme kort, så behold visningen
    var related = e.relatedTarget;
    if (related && related.closest && related.closest('[data-color-url]')) return;

    var card = getCard(swatch);
    if (!card) return;
    var preview = card.querySelector('.card__color-preview');
    if (preview) preview.classList.remove('is-visible');
  });
})();
